import type { OwnProps, StateProps } from 'components/common-form/sidePanel/status/Status.connect';
import { connect } from 'react-redux';
import * as addonSelector from 'state/addonForm/addonForm.selector';
import type { AppState } from 'state/state.model';

const mapStateToProps = (state: AppState, { tabId }: OwnProps): StateProps => {
  const status = addonSelector.getWorkflowStatus(state, tabId);

  return {
    status,
  };
};

export const connectStatus = connect(mapStateToProps);
